import { render, staticRenderFns } from "./PriceActions.vue?vue&type=template&id=d13fc398&"
import script from "./PriceActions.vue?vue&type=script&lang=js&"
export * from "./PriceActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports